const Home = () => {
  return (
    <div className="content">
      <div className="container center">
        <h1>UpYoung</h1>
      </div>
    </div>
  );
};

export default Home;
